/**
 * Couleur de marque du site, avec repli neutre.
 *
 * Le fallback historique etait `#ff7f00`, repete dans une vingtaine de
 * fichiers. Deux problemes : c'etait un orange tres proche des anciennes
 * couleurs de marque Dynamo (#faa619 / #ffa700), donc une configuration
 * manquante passait totalement inapercue tant que la marque etait orange ;
 * et il fallait le corriger a vingt endroits a chaque changement.
 *
 * Le repli est desormais neutre et centralise ici. S'il est utilise, c'est
 * que `mondayMindbody.customization.color` n'etait pas disponible : on le
 * signale une fois dans la console plutot que de peindre l'application dans
 * une couleur plausible et de laisser le probleme invisible.
 */
export const DEFAULT_BRAND_COLOR = '#1a1a1a';

let missingConfigReported = false;

export const getBrandColor = (): string => {
  const color =
    typeof mondayMindbody !== 'undefined' ? mondayMindbody?.customization?.color : undefined;

  if (color) {
    return color;
  }

  if (!missingConfigReported) {
    missingConfigReported = true;
    console.warn(
      '[monday-mindbody] couleur de marque indisponible (mondayMindbody.customization.color) : repli sur ' +
        DEFAULT_BRAND_COLOR,
    );
  }

  return DEFAULT_BRAND_COLOR;
};
